export default {
  install(Vue) {
    /**
     *
     * @param {string} name Account name
     * @returns Uppercase acronym of account name
     */
    Vue.prototype.$getAccountShortName = (name) =>
      name
        .split(" ")
        .slice(0, 2)
        .map((i) => i.charAt(0))
        .join("");
  },
};
